import { useTranslation } from 'react-i18next';
import { HeartFillIcon, HeartLineIcon, Row, Text } from 'ui';

type P = {
  count: number;
  liked: boolean;
};

const LikeCount = ({ count, liked }: P) => {
  const { t } = useTranslation();
  return (
    <Row align="middle" className="like-count">
      {liked ? (
        <HeartFillIcon className="like-count__like-icon__filled" size="extra-small" />
      ) : (
        <HeartLineIcon className="like-count__like-icon" size="extra-small" />
      )}
      <Text size="small" type="secondary">
        {t('likesCount', { count })}
      </Text>
    </Row>
  );
};

export default LikeCount;
